import $ from 'jquery'
import Vue from 'vue'
import i18n from './plugins/vue-i18n'
import vuetify from './plugins/vuetify'
import store from './store'

import PetitionList from './shared-vue-components/ui/petitionList.vue'
import PopularPetitionList from './shared-vue-components/ui/popularPetitionList.vue'

$(document).ready(() => {
  // Initialise Vue
  Vue.config.productionTip = false

  const popularPetitionListEl = document.getElementById('popular_petition_list_box')
  const popularPetitionListProps = {
    ...JSON.parse(popularPetitionListEl.getAttribute('data')),
    ...$(popularPetitionListEl).data()
  }

  if (popularPetitionListEl && popularPetitionListProps) {
    new Vue({
      render: h => h(PopularPetitionList, { props: popularPetitionListProps }),
      i18n,
      vuetify,
      store
    }).$mount(popularPetitionListEl)
  } else if (!popularPetitionListEl) {
    // eslint-disable-next-line no-console
    console.warn('No popular_petition_list_box on this page.')
  } else if (!props) {
    // eslint-disable-next-line no-console
    console.warn('No data- specificed popular_petition_list_box on this page.')
  }

  const petitionListEl = document.getElementById('petition_list_box')
  const petitionListProps = {
    ...JSON.parse(petitionListEl.getAttribute('data')),
    ...$(petitionListEl).data()
  }

  if (petitionListEl && petitionListProps) {
    new Vue({
      render: h => h(PetitionList, { props: petitionListProps }),
      i18n,
      vuetify,
      store
    }).$mount(petitionListEl)
  } else if (!petitionListEl) {
    // eslint-disable-next-line no-console
    console.warn('No petition_list_box on this page.')
  } else if (!props) {
    // eslint-disable-next-line no-console
    console.warn('No data- specificed petition_list_box on this page.')
  }
})
